<template>
    <div class="org-tree" v-cloak>
        <div v-if="showIncludeClosed" class="pos-rel row">
            <div class="includeSubComs mt10">
                <el-checkbox v-model="includeClosed" @change="handleCheckedChange">显示关闭网点</el-checkbox>
            </div>
        </div>
        <el-input v-if="enableSearch != null && enableSearch == true" class="mt10 mb10" placeholder="输入关键字进行过滤" v-model="filterText">
            <i slot="suffix" class="el-input__icon el-icon-search" @click="handleFilterTextClick"></i>
        </el-input>
        <el-radio-group v-if="isRadio" v-model="checkComId" style="display: block;height: calc(100% - 52px - 28px)">
            <el-tree class="filter-tree" :accordion="accordion" :load="loadNode" lazy="" :node-key="'nodeKey'" :data="comList" :highlight-current="highlightCurrent" :props="defaultProps" @node-click="clickNode" :filter-node-method="filterNode" ref="comTree" :render-content="renderContent" @node-expand="nodeExpand" @node-collapse="nodeCollapse" :default-expanded-keys="openNodeKeys"></el-tree>
        </el-radio-group>
        <div v-else style="height: calc(100% - 52px - 28px)">
            <el-tree class="filter-tree" :accordion="accordion" :load="loadNode" lazy="" :node-key="'nodeKey'" :data="comList" :highlight-current="highlightCurrent" :props="defaultProps" @node-click="clickNode" :filter-node-method="filterNode" ref="comTree" :render-content="renderContent" @node-expand="nodeExpand" @node-collapse="nodeCollapse" :default-expanded-keys="openNodeKeys"></el-tree>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'

    import { Vue, MsgBox, filterByName, Routes } from '../../app.vues'

    import userApi from '../../api/user'
    import servicerApi from '../../api/servicer'

    export default {
        name: 'swb-org-tree',
        desc: '组织架构树组件',
        props: {
            enableSearch: {
                type: Boolean,
                default: true
            },
            isRadio: {
                type: Boolean,
                default: false
            },
            isCom: {    // 是否获取全部的公司
                type: Boolean,
                default: false
            },
            accordion: {    // 是否手风琴模式
                type: Boolean,
                default: false
            },
            isSelectThisLevel: { //本级是否可选
                type: Boolean,
                default: false
            },
            includeUnOpenedFlag: { //是否包含未开店
                type: Boolean,
                default: false
            },
            dblclickFlag: { // 是否双击事件
                type: Boolean,
                default: false
            },
            showIncludeClosed: {
                type: Boolean,
                default: true
            },
            closedComSelect: {
                type: Boolean,
                default: false
            },
            bizDepart: {
                type: Boolean,
                default: false
            },
            bizUnitId: {
                type: Number,
                default: null
            }
        },
        watch: {},
        data: function () {
            return {
                bizUnit : false,
                highlightCurrent: true,
                filterText: "",
                comList: [],
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                checkComId: null,
                checkComItem: {},
                thisComId: null,
                treeCollapse: true,
                includeClosed: false,
                openNodeKeys: [],
                lastSelectedNodeId: null, // 最后一次触发节点Id
                lastSelectTime: null // 最后一次触发时间
            }
        },
        created: function () {
            this.bizUnit = !this.bizDepart;
            this.getCurrentUserInfo();
        },
        methods: {
            handleFilterTextClick: function () {
                let filterText = this.filterText;
                //
                let postData = {};
                postData.bizUnit = this.bizUnit;
                postData.lazyFlag = false;
                postData.includeUnOpenedFlag = this.includeUnOpenedFlag;
                postData.name = filterText;
                postData.isCom = this.isCom;
                if(Utils.isNoB(this.includeClosed) || this.includeClosed == false) {
                    postData.closed = false
                }
                let self = this;
                let theLoad = MsgBox.loading();
                servicerApi.getServicerComList(postData, function (result, jqXhr) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        let data = result.data;
                        //
                        //对树节点数据进行过滤处理（设置 nodeKey）
                        self.normalizeTreeNode(data);
                        //
                        let comList = Utils.merge([], data);
                        //
                        let nodeKey = [];
                        let comIds = result.codeName || null;
                        if(!Utils.isNoB(comIds)) {
                            nodeKey = JSON.decode(comIds) || [];
                        }
                        self.comList = comList;
                        self.openNodeKeys = Utils.merge([], nodeKey);
                    } else {
                        self.comList = [];
                        self.$message.error(result.message);
                    }
                });
            },
            handleCheckedChange: function () {
                this.getLazyComList();
            },
            nodeExpand(data, node, vueComponent){
                this.openNodeKeys.push(data.nodeKey);
            },
            nodeCollapse(data, node, vueComponent){
                this.openNodeKeys.remove(data.nodeKey);
            },
            getCurrentUserInfo: function () {
                let self = this;
                userApi.getUserInfoByContext({}, function (result, jqXhr) {
                    if(result.type == 'info') {
                        let data = result.data;
                        self.thisComId = data.scopeEntity.comId;
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            loadNode(node, resolve) {
                let self = this;
                let dbChildren = node.data.children || [];
                if(node.level === 0) {
                    this.getLazyComList();
                } else {
                    if(node.level >= 10) {
                        return resolve(dbChildren);
                    }
                    let parentId = node.data.id;
                    if(this.bizUnit) {
                        parentId = node.data.bizUnitId;
                    }
                    let postData = {};
                    postData.bizUnit = this.bizUnit;
                    postData.lazyFlag = true;
                    postData.parentId = parentId;
                    postData.includeUnOpenedFlag = this.includeUnOpenedFlag;
                    postData.isCom = this.isCom;
                    if(Utils.isNoB(this.includeClosed) || this.includeClosed == false) {
                        postData.closed = false
                    }
                    //
                    servicerApi.getServicerComList(postData, function (result) {
                        if(result.type == 'info') {
                            let data = result.data;
                            self.normalizeTreeNode(data);
                            let children = data;
                            if(dbChildren != null) {
                                children = dbChildren.concat(data);
                            }
                            resolve(children);
                        } else {
                            resolve([]);
                            self.$message.warning(result.message);
                        }
                    });
                }
            },
            getLazyComList: function (parentId) {
                let self = this;
                let postData = {};
                postData.bizUnit = this.bizUnit;
                postData.lazyFlag = true;
                postData.includeUnOpenedFlag = this.includeUnOpenedFlag;
                postData.parentId = parentId || null;
                postData.isCom = this.isCom;
                if(Utils.isNoB(this.includeClosed) || this.includeClosed == false) {
                    postData.closed = false
                }
                servicerApi.getServicerComList(postData, function (result, jqXhr) {
                    if(result.type == 'info') {
                        let data = result.data;
                        //
                        //对树节点数据进行过滤处理（设置 nodeKey）
                        self.normalizeTreeNode(data);
                        //
                        self.comList = data;
                        //
                        if(data != null && data.length > 0) {
                            let item = data[0];
                            self.notityInitChange(item);
                        }
                    } else {
                        self.$message.error(result.message);
                    }
                })
            },
            filterNode: function (value, data) {
                if(!value) {
                    return true;
                }
                return data.name.indexOf(value) !== -1;
            },
            renderContent: function (createElement, node) {
                let leafFlag = node.data.leafFlag;
                if(leafFlag) {
                    let children = node.data.children || [];
                    if(children == null || children.length <= 0) {
                        leafFlag = true;
                    } else {
                        leafFlag = false;
                    }
                }
                node.node.isLeaf = leafFlag;
                let selfTree = this;
                return createElement({
                    data: function () {
                        return {
                            item: node,
                            checkComId: selfTree.checkComId,
                            thisComId: selfTree.thisComId,
                            isRadio: selfTree.isRadio,
                            isSelectThisLevel: selfTree.isSelectThisLevel
                        };
                    },
                    template: '<span style=" display: inline-block; width: calc(100% - 25px);">' +
                    '<span class="inline-block ellipsis pr10" style="width: 100%;margin-top:3px;" v-if = "isRadio == false || (!isSelectThisLevel && thisComId == item.data.id)">' +
                    '<i v-if = "item.data.shopFlag" class="icon iconfont icon-mendian1 mr5 font-blue"></i>' +
                    '<i v-if = "item.data.orgType == 0" class="icon iconfont icon-icon-folder mr5 font-gray"></i>' +
                    '<i v-if = "item.data.orgType == 1 && item.data.shopFlag == false" class="icon iconfont icon-gongsi1 mr5 font-blue"></i>' +
                    '<span>{{item.data.name}}</span>' +
                    '<el-tag type="danger" v-if="item.data.closed">闭</el-tag>' +
                    '</span>' +
                    '</div>' +
                    '<span v-else>' +
                    '<el-radio class = "radio" :disabled = "item.data.closed" v-model="checkComId" :label="item.data.id">' +
                    '<i v-else-if = "item.data.shopFlag" class="icon iconfont icon-mendian1 mr10 font-blue"></i>' +
                    '<i v-else class="icon iconfont icon-gongsi1 mr10 font-blue"></i>' +
                    '<span>{{item.data.name}}</span>' +
                    '<el-tag size="small" type="danger" v-if="item.data.closed">闭</el-tag> <el-tag size="small" type="success" v-if="item.data.shopFlag && item.data.tagId != null">{{item.data.tagName}}</el-tag>' +
                    '</el-radio>' +
                    '</span>' +
                    '</span>',
                    methods: {
                        handleTooltip(item){
                            let toolTip = item.name;
                            if(item.closed) {
                                toolTip += "【闭店】";
                            }
                            if(item.tagId != null) {
                                toolTip += "【" + item.tagName + "】";
                            }
                            return toolTip;
                        }
                    }
                });
            },
            normalizeTreeNode: function (data) {
                Utils.forEachTreeNode(data, function (nodeData) {
                    let nodeId = nodeData['id'] || null;
                    if(nodeId == null) {
                        nodeId = Utils.genUniqueStr();
                    }
                    //
                    nodeData['nodeKey'] = 'com-' + nodeId;
                }, function (treeNode) {
                    let comSons = treeNode.comSons || [];
                    let departs = treeNode.departs || [];
                    let children = departs.concat(comSons);
                    //
                    treeNode.children = children;
                    return children;
                });
            },
            clickNode: function (data) {
                if(this.isRadio) {
                    this.checkComId = data.id;
                    this.checkComItem = data
                } else {
                    if(this.dblclickFlag) {
                        let nodeId = data.id + "";
                        //
                        let lastSelectedNodeId = this.lastSelectedNodeId;
                        let lastSelectTime = this.lastSelectTime;
                        if(!Utils.isNoB(lastSelectedNodeId) && !Utils.isNoB(lastSelectTime)) {
                            let time = new Date().getTime();
                            let t = time - lastSelectTime;
                            if(lastSelectedNodeId === nodeId && t < 500) {
                                this.notityChange(data);
                            }
                        }
                        //
                        this.lastSelectedNodeId = nodeId;
                        this.lastSelectTime = new Date().getTime();
                    } else {
                        this.notityChange(data);
                    }
                }
            },
            notityChange: function (data) {
                let closed = false;
                //
                let resultData = {};
                resultData.id = data.id;
                resultData.name = data.name;
                resultData.level = data.level;
                resultData.parentId = data.parentId;
                resultData.comId1 = data.comId1;
                resultData.comId2 = data.comId2;
                resultData.comId3 = data.comId3;
                resultData.comId4 = data.comId4;
                resultData.shopFlag = data.shopFlag;
                resultData.closed = data.closed;
                resultData.bizUnitId = data.bizUnitId;
                resultData.bizUnitName = data.bizUnitName;
                //
                closed = data.closed;
                //
                if(closed && this.closedComSelect == false) {
                    this.$message({
                        message: '当前网点已关闭，不可选中！',
                        type: 'warning',
                        offset: '200'
                    });
                    return false;
                }
                this.$emit('notity-change', resultData);
            },
            notityInitChange: function (data) {
                //
                let resultData = {};
                resultData.id = data.id;
                resultData.name = data.name;
                resultData.level = data.level;
                resultData.parentId = data.parentId;
                resultData.comId1 = data.comId1;
                resultData.comId2 = data.comId2;
                resultData.comId3 = data.comId3;
                resultData.comId4 = data.comId4;
                resultData.shopFlag = data.shopFlag;
                resultData.closed = data.closed;
                resultData.bizUnitId = data.bizUnitId;
                resultData.bizUnitName = data.bizUnitName;
                this.$emit('notity-init-change', resultData);
            },
            getDlgResult(){
                let self = this;
                let result = {};
                if(this.checkComId != null) {
                    result.type = 'info';
                    result.data = self.checkComItem;
                } else {
                    result.type = 'warn';
                    result.message = '请选择机构';

                }
                return result;
            },
            //组织树收缩
            showTreeCollapse: function () {
                this.treeCollapse = this.treeCollapse ? false : true;
                this.$emit('show-tree-collapse', this.treeCollapse)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/orgStruct/ServicerOrgTree.vue